import React from 'react';
import PropTypes from 'prop-types';

export default function DownloadTrackButton({ link }) {
	return (
		<a download href={link}>
			<i className="downloadTrackButton icon-save" />
		</a>
	);
}

DownloadTrackButton.propTypes = {
	link: PropTypes.string,
};
